import { AppThunk } from '../../../store/reducers';
import { GET, POST, PUT } from '../../../service/HttpMethod';
import {
	InitialState,
	Details,
	Lists,
	SearchLists,
	ActionConstant,
	ActionType,
	Plan,
	PlanLists,
} from './types';
import { toastFunction } from '../../../helpers/toastShow';

const initialState: InitialState = {
	detailsFetching: true,
	details: {
		firstName: '',
		lastName: '',
		email: '',
		phone: '',
		location: '',
		companyName: '',
		id: 0,
	},
	statusCode: 0,
	planStatusCode: 0,
	projectdetails: [],
	projectdetailsFetching: true,
	count: 0,
	searchhistory: [],
	searchhistoryFetching: true,
	searchcount: 0,
	planCount: 0,
	list: [],
	listFetching: true,
	summaryFetching: true,
	planlist: [],
	plan: {
		id: '',
		name: '',
		description: '',
		documentCount: '',
		documentSize: '',
		scanCount: '',
		projectCount: '',
		tradeCount: '',
		userCount: '',
		duration: '',
		durationUnit: 0,
		amount: '',
	},
	ss: {},
};

const GetPlanDetailsAction = (data: PlanLists): ActionType => ({
	type: ActionConstant.GET_PLAN_LIST,
	data,
});
const GetSbscriptionSummaryAction = (data: any): ActionType => ({
	type: ActionConstant.GET_SUBSCRIPTION_SUMMARY,
	data,
});
const GetPlanDetailAction = (data: Plan): ActionType => ({
	type: ActionConstant.GET_PLAN_DETAILS,
	data,
});
export const clearSbscriptionSummary = (): ActionType => ({
	type: ActionConstant.CLEAR_SUBSCRIPTION_SUMMARY,
});

export const clearPlanStatus = (): ActionType => ({ type: ActionConstant.CLEAR_PLAN_STATUS });

export const clearPlanDetail = (): ActionType => ({ type: ActionConstant.CLEAR_PLAN_DETAIL });

export const clearPlanDetails = (): ActionType => ({ type: ActionConstant.CLEAR_PLAN_DETAILS });

const GetDetailsAction = (data: Details): ActionType => ({
	type: ActionConstant.GET_DETAILS,
	data,
});

const GetProjectDetailsAction = (data: Lists): ActionType => ({
	type: ActionConstant.GET_PROJECT_DETAILS,
	data,
});
const GetSearchHistoryAction = (data: SearchLists): ActionType => ({
	type: ActionConstant.GET_SEARCHHISTORY,
	data,
});
// const GetEnrepriseRequestAction = (data:any): ActionType => ({
// 	type: ActionConstant.GET_ENTERPRISE_REQUEST,
// 	data,
// });

export const clearDetails = (): ActionType => ({ type: ActionConstant.CLEAR_DETAILS });
export const clearProjectDetails = (): ActionType => ({
	type: ActionConstant.CLEAR_PROJECT_DETAILS,
});
export const clearStatus = (): ActionType => ({ type: ActionConstant.CLEAR_STATUS });
export const clearSearchHistory = (): ActionType => ({
	type: ActionConstant.CLEAR_SEARCHHISTORY,
});

export const getDetails = (data: any = {}): AppThunk => {
	// project details
	const getConfig = { url: `users/${data}` };
	return async (dispatch) => {
		try {
			const { data = {} } = await GET(getConfig);
			dispatch(GetDetailsAction(data));
		} catch (error) {
			if (error && error.data && error.data.message) {
				dispatch(toastFunction('Error', error.data.message, ''));
			} else {
				dispatch(toastFunction('Error', 'Something went wrong', ''));
			}
		}
	};
};

export const getProjectDetails = (data: any = {}): AppThunk => {
	// project details
	const getConfig = { url: `users/${data}/projects` };
	return async (dispatch) => {
		try {
			const { data = {} } = await GET(getConfig);
			dispatch(GetProjectDetailsAction(data.data));
		} catch (error) {
			if (error && error.data && error.data.message) {
				dispatch(toastFunction('Error', error.data.message, ''));
			} else {
				dispatch(toastFunction('Error', 'Something went wrong', ''));
			}
		}
	};
};
export const getSearchHistory = (): AppThunk => {
	// project details
	const getConfig = { url: `history` };
	return async (dispatch) => {
		try {
			const { data = {} } = await GET(getConfig);
			dispatch(GetSearchHistoryAction(data));
		} catch (error) {
			if (error && error.data && error.data.message) {
				dispatch(toastFunction('Error', error.data.message, ''));
			} else {
				dispatch(toastFunction('Error', 'Something went wrong', ''));
			}
		}
	};
};

export function updateProfile(datas: any = {}, userId: number): AppThunk {
	// edit project details
	const putConfig = {
		data: datas,
		url: `users/${userId}`,
	};
	return async (dispatch) => {
		try {
			const { status = 0 } = await PUT(putConfig);
			dispatch({ type: ActionConstant.GET_STATUS, status });
			dispatch(clearDetails());
			dispatch(getDetails(userId));
			dispatch(toastFunction('Success', 'Profile updated successfully', ''));
		} catch (error) {
			dispatch({ type: ActionConstant.GET_STATUS, status: 0 });
			dispatch(toastFunction('Error', 'Profile updation failed', ''));
		}
	};
}

export const getPlanDetails = (): AppThunk => {
	// plan details
	const getConfig = { url: `plan` };
	return async (dispatch) => {
		try {
			const { data = {} } = await GET(getConfig);
			dispatch(GetPlanDetailsAction(data.data));
		} catch (error) {
			dispatch(toastFunction('Error', 'Plans fetching failed', ''));
		}
	};
};

export const getSubscriptionSummary = (): AppThunk => {
	// plan details
	const getConfig = { url: `subscription-summary` };
	return async (dispatch) => {
		try {
			dispatch(clearSbscriptionSummary());
			const { data = {} } = await GET(getConfig);
			dispatch(GetSbscriptionSummaryAction(data));
		} catch (error) {
			if (error && error.data && error.data.message) {
				dispatch(toastFunction('Error', error.data.message, ''));
			} else {
				dispatch(toastFunction('Error', 'Subscription fetching failed', ''));
			}
		}
	};
};

export const getPlan = (planId: number): AppThunk => {
	// plan details
	const getConfig = { url: `plan/${planId}` };
	return async (dispatch) => {
		try {
			const { data = {} } = await GET(getConfig);
			dispatch(GetPlanDetailAction(data.data));
		} catch (error) {
			dispatch(toastFunction('Error', 'Plan fetching failed', ''));
		}
	};
};

type BillingAddress = {
	firstname: string;
	lastname: string;
	addressline1: string;
	city: string;
	state: string;
	phone: string;
	zipcode: string;
};
export function subscription(
	paymentMethodId: string | null,
	planId: number,
	autoRenew: boolean,
	billingAddress: BillingAddress,
): AppThunk {
	const data = {
		paymentMethodId,
		planId,
		autoRenew,
		billingAddress,
	};
	const postConfig = {
		data,
		url: `subscription`,
	};
	return async (dispatch) => {
		try {
			dispatch({ type: ActionConstant.GET_PLAN_SUBSCRIBE_START });
			const { data = {} } = await POST(postConfig);
			if (!data.id) {
				throw new Error(data.message || 'Stripe did not confirm the subscription payment');
			}
			dispatch(clearPlanDetails());
			dispatch(clearPlanStatus());
			dispatch({ type: ActionConstant.GET_PLAN_STATUS, status: 200 });
			dispatch(getPlanDetails());
			if (data.planStatus === 'pending') {
				dispatch(toastFunction('Success', 'The invoice will be sent to your email', ''));
			}
			dispatch(getSubscriptionSummary());
		} catch (error) {
			dispatch({ type: ActionConstant.GET_PLAN_STATUS, status: 400 });
			dispatch(
				toastFunction(
					'Error',
					error?.data?.message ||
						error?.message ||
						'Subscription payment failed. Please try again.',
					'',
				),
			);
		} finally {
			dispatch({ type: ActionConstant.GET_PLAN_SUBSCRIBE_END });
		}
	};
}

export function unsubscribe(id: number): AppThunk {
	const data = { id };
	const postConfig = {
		data,
		url: `unsubscribe`,
	};
	return async (dispatch) => {
		try {
			dispatch({ type: ActionConstant.GET_PLAN_UNSUBSCRIBE_START });
			const { data = {} } = await POST(postConfig);
			if (data.id) {
				dispatch({ type: ActionConstant.GET_PLAN_STATUS, status: 200 });
				dispatch(clearPlanDetails());
				dispatch(clearPlanStatus());
				dispatch(getPlanDetails());
				dispatch(toastFunction('Success', 'Plan unsubscribed successfully', ''));
				dispatch({ type: ActionConstant.GET_PLAN_UNSUBSCRIBE_END });
				dispatch(getSubscriptionSummary());
			}
		} catch (error) {
			dispatch({ type: ActionConstant.GET_PLAN_STATUS, status: 400 });
			dispatch(toastFunction('Error', error.data.message, ''));
		}
	};
}

export function unsubscribeEnterprise(planId: number): AppThunk {
	const data = { planId };
	const putConfig = {
		data,
		url: `unsubscribe`,
	};
	return async (dispatch) => {
		dispatch({ type: ActionConstant.GET_PLAN_UNSUBSCRIBE_START });
		const { data = {} } = await PUT(putConfig);
		if (data) {
			dispatch({ type: ActionConstant.GET_PLAN_STATUS, status: 200 });
			dispatch(clearPlanDetails());
			dispatch(clearPlanStatus());
			dispatch(getPlanDetails());
			dispatch(toastFunction('Success', 'Plan unsubscribed successfully', ''));
			dispatch({ type: ActionConstant.GET_PLAN_UNSUBSCRIBE_END });
			dispatch(getSubscriptionSummary());
		}
	};
}

export function requestPlan(id: number, status: boolean): AppThunk {
	const data = { id, status };
	const postConfig = {
		data,
		url: `enterprise`,
	};
	return async (dispatch) => {
		const resp = await POST(postConfig);
		if (resp) {
			// dispatch(GetEnterpriseRequestAction(resp.data[0]));
			dispatch({ type: ActionConstant.GET_PLAN_STATUS, status: 200 });
			dispatch(clearPlanDetails());
			dispatch(clearPlanStatus());
			dispatch(getPlanDetails());
			if (status) {
				dispatch(toastFunction('Success', 'The request was raised successfully.', ''));
			} else {
				dispatch(toastFunction('Success', 'The request was cancelled successfully.', ''));
			}
		}
	};
}

export function payInvoice(id: string): AppThunk {
	const data = { id };
	const postConfig = {
		data,
		url: `payinvoice`,
	};
	return async (dispatch) => {
		const { data = {} } = await POST(postConfig);
		if (data) {
			dispatch({ type: ActionConstant.GET_PLAN_STATUS, status: 200 });
			dispatch(clearPlanDetails());
			dispatch(clearPlanStatus());
			dispatch(getPlanDetails());
			if (data.paid) {
				dispatch(toastFunction('Success', 'Plan renewed successfully.', ''));
			}
		}
	};
}

export function openCustomerPortal(): AppThunk {
	const data = { id: 1 };
	const postConfig = {
		data,
		url: `open-customer-portal`,
	};
	return async (dispatch) => {
		try {
			const { data = {} } = await POST(postConfig);
			window.open(data.url, '_blank');
		} catch (error) {
			dispatch(toastFunction('Error', error.data.message, ''));
		}
	};
}

function profileReducer(state = initialState, action: ActionType): InitialState {
	switch (action.type) {
		case ActionConstant.GET_DETAILS: {
			const { data } = action;
			return {
				...state,
				details: data,
				detailsFetching: false,
			};
		}
		case ActionConstant.GET_SEARCHHISTORY: {
			const { searchHistory = [] } = action.data;
			return {
				...state,
				searchhistory: [...state.searchhistory, ...searchHistory],
				searchhistoryFetching: false,
			};
		}
		// case ActionConstant.GET_ENTERPRISE_REQUEST: {
		// 	const {  enterpriseStatusCode } = action.data;
		// 	return {
		// 		...state,
		// 		enterpriseStatusCode: [...state.enterpriseStatusCode, enterpriseStatusCode],
		// 	};
		// }

		case ActionConstant.GET_PROJECT_DETAILS: {
			const { count = 0, rows = [] } = action.data;
			return {
				...state,
				projectdetails: [...state.projectdetails, ...rows],
				count,
				projectdetailsFetching: false,
			};
		}
		case ActionConstant.GET_STATUS: {
			return {
				...state,
				statusCode: action.status,
			};
		}
		case ActionConstant.CLEAR_DETAILS: {
			return {
				...state,
				details: {
					firstName: '',
					lastName: '',
					phone: '',
					email: '',
					location: '',
					companyName: '',
					id: 0,
				},
				detailsFetching: true,
			};
		}
		case ActionConstant.CLEAR_SEARCHHISTORY: {
			return {
				...state,
				searchhistory: [],
				searchcount: 0,
				searchhistoryFetching: true,
			};
		}
		case ActionConstant.CLEAR_PROJECT_DETAILS: {
			return {
				...state,
				projectdetails: [],
				count: 0,
				projectdetailsFetching: true,
			};
		}
		case ActionConstant.CLEAR_STATUS: {
			return {
				...state,
				statusCode: 0,
			};
		}
		case ActionConstant.GET_PLAN_LIST: {
			const { planCount = 0, rows = [] } = action.data;
			state.planlist = [];
			return {
				...state,
				planlist: [...state.planlist, ...rows],
				planCount,
				listFetching: false,
			};
		}
		case ActionConstant.GET_SUBSCRIPTION_SUMMARY: {
			const { data } = action;
			return {
				...state,
				ss: data,
				summaryFetching: false,
			};
		}
		case ActionConstant.CLEAR_SUBSCRIPTION_SUMMARY: {
			return {
				...state,
				ss: initialState.ss,
				summaryFetching: true,
			};
		}
		case ActionConstant.CLEAR_PLAN_DETAILS: {
			return {
				...state,
				planlist: [],
				planCount: 0,
				listFetching: true,
			};
		}
		case ActionConstant.GET_PLAN_DETAILS: {
			const { data } = action;
			return {
				...state,
				plan: data,
				listFetching: false,
			};
		}
		case ActionConstant.GET_PLAN_STATUS: {
			return {
				...state,
				planStatusCode: action.status,
			};
		}
		case ActionConstant.GET_PLAN_SUBSCRIBE_START: {
			return {
				...state,
				listFetching: true,
			};
		}
		case ActionConstant.GET_PLAN_SUBSCRIBE_END: {
			return {
				...state,
				listFetching: false,
			};
		}
		case ActionConstant.GET_PLAN_UNSUBSCRIBE_START: {
			return {
				...state,
				listFetching: true,
			};
		}
		case ActionConstant.GET_PLAN_UNSUBSCRIBE_END: {
			return {
				...state,
				listFetching: false,
			};
		}
		case ActionConstant.CLEAR_PLAN_STATUS: {
			return {
				...state,
				planStatusCode: 0,
			};
		}
		default:
			return state;
	}
}

export default profileReducer;
